import React from "react";
import { ListItem, Typography } from "@material-ui/core";

interface UserEditFailedActionListProps {
	//The user name that the edit component was attempting to change the current user name to.
	editedUserName?: string;
	//The current user name for the user under editing.
	userName?: string;
	//A list of all of the failed add role actions tat occurred.
	failedAddActions?: string[];
	//A list of all of the failed remove role actions that occurred.
	failedRemoveActions?: string[];
}

/**
 * This component is used for displaying lists of failed actions that occured while attempting to edit the user.
 *  @param props
 */
export const UserEditFailedActionsList = (props: UserEditFailedActionListProps) => {
	return (
		<div style={{ textAlign: "center" }}>
			{props.editedUserName && (
				<Typography color={"error"}>
					Failed to Change the User Principal Name {props.userName} to {props.editedUserName}
				</Typography>
			)}
			{props.failedAddActions && props.failedAddActions.length > 0 && (
				<div>
					<Typography color={"error"}>Failed to add the following roles to the user:</Typography>
					{props.failedAddActions.map((failedAction) => {
						<ListItem key={failedAction}>
							<div>{failedAction}</div>;
						</ListItem>;
					})}
				</div>
			)}
			{props.failedRemoveActions && props.failedRemoveActions.length > 0 && (
				<div>
					<Typography color={"error"}>Failed to remove the following roles to the user:</Typography>
					{props.failedRemoveActions.map((failedAction) => {
						<ListItem key={failedAction}>
							<div>{failedAction}</div>;
						</ListItem>;
					})}
				</div>
			)}
		</div>
	);
};
